import { render } from "./WhyJoinUs.vue?vue&type=template&id=555ae42c&scoped=true"
import script from "../js/why-join-us.js?vue&type=script&lang=js"
export * from "../js/why-join-us.js?vue&type=script&lang=js"

import "./WhyJoinUs.vue?vue&type=style&index=0&id=555ae42c&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555ae42c"]])

export default __exports__